<template>
  <AdminEditEmployeePage />
</template>

<script setup lang="ts">
import { useSeoMeta } from "@unhead/vue";
import AdminEditEmployeePage from "shared-ui/pages/AdminEditEmployeePage.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

useSeoMeta({
  title: () => t("admin_edit_employee.title"),
});

definePage({
  meta: {
    requiresAuth: true,
    requiresAdmin: true,
    layout: "AppLayout",
  },
});
</script>
